import { Card, CardBody, Col, Row } from "reactstrap";
import { TableContainer, Spinner, ScreenOverlay } from "../../../../components/Common";
import { toastError } from "../../../../helpers/toast-helper";
import { useWorkSessionsList } from "../../../../common/hooks/api/work-sessions";
import { Columns } from "../../config";
import { getResponseData } from "../../../../helpers/response-helper";
import usePagination from "../../../../common/hooks/pagination";
import { useNavigate } from "react-router-dom";

const WorkSessionsList = () => {
    const {
        pagination,
        setPagination,

        sorting,
        setSorting,

        globalFilter,
        setGlobalFilter,

        params,

        getPageCount,
    } = usePagination();

    const navigate = useNavigate();

    const { data: sessionsResponse, isLoading } = useWorkSessionsList(params, {
        onError: () => {
            toastError("Cannot fetch work sessions");
        }
    });
    const { data, meta } = getResponseData(sessionsResponse);
    const pageCount = getPageCount(meta);

    return (
        <Row>
            <Col lg="12">
                <Card>
                    <CardBody>
                        <TableContainer
                            columns={Columns}
                            data={data || []}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search..."
                            isCustomPageSize={false}
                            isAddButton={false}
                            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                            pagination="pagination"

                            manualPagination
                            paginationState={pagination}
                            onPaginationChange={setPagination}
                            pageCount={pageCount}

                            manualSorting
                            sortingState={sorting}
                            onSortingChange={setSorting}

                            manualGlobalFilter={true}
                            globalFilterState={globalFilter}
                            onGlobalFilterChange={setGlobalFilter}

                            onRowClick={(rowData) => {
                                navigate(`/work-sessions/${rowData.id}`);
                            }}
                        />
                    </CardBody>
                </Card>
            </Col>
            {isLoading && (
                <>
                    <ScreenOverlay/>
                    <Spinner/>
                </>
            )}
        </Row>
    );
};

export default WorkSessionsList;
